<template>
    <el-dialog
            title="选择客户"
            :visible="true"
            width="60%"
            :append-to-body=true
            :before-close="handleClose">
        <el-form ref="form1" :model="form1" :inline="true"  label-width="120px">
            <el-form-item label="客户代码:">
                    <el-input v-model="form1.instockNum"></el-input>
            </el-form-item>
            <el-form-item label="客户名称:">
                    <el-input v-model="form1.number" ></el-input>
            </el-form-item>
            <el-form-item>
                    <el-button type="primary">搜索</el-button>
            </el-form-item>
        </el-form>
        <el-table
                ref="multipleTable"
                :data="tableData"
                v-loading="loading"
                height="350"
                border
                stripe
                style="width: 100%">
            <el-table-column
                    prop="instockCode"
                    label="客户编号"
                    width="120"
                    >
            </el-table-column>
            <el-table-column
                    prop="pCode"
                    label="客户代码"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="instockNum"
                    label="客户名称"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop=""
                    label="操作"
                    width="180"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-button type="text" size="small">选择</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--分页-->
        <el-pagination
                style="margin: 20px 0"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNo"
                :page-sizes="[20, 50, 100, 200]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalSize">
        </el-pagination>
        <!--<span slot="footer" class="dialog-footer">
   <el-button @click="handleClose">取 消</el-button>
   <el-button type="primary" @click="handleClose">确 定</el-button>
 </span>-->
    </el-dialog>

</template>

<script>
    export default {
        name: "selectCustomer",
        data(){
            return {
                loading:false,
                form1: {
                    instockNum: '',
                    pCode: '',
                    date1: '',
                    date2: '',
                    code: '',
                    number: '',
                    sCode: '',
                    pName: '',
                    label:'',
                    type:'',
                    amount:'',
                    instock:'',
                    name:'',
                    name1:'',
                    desc:''
                },
                tableData: [
                ],
                //分页
                pageNo: 1,
                pageSize: 20,
                totalSize: 0,

            }
        },
        created(){

        },
        methods:{
            onSearch(){

            },
            /*分页*/
            handleSizeChange(val) {
                this.pageSize = val;
                this.pageNo = 1;
                this.onSearch();
            },
            handleCurrentChange(val) {
                this.pageNo = val;
                this.onSearch();
            },
            handleClose(){
                this.$emit('handleClose');
            }
        }
    }
</script>

<style scoped>

</style>